import React, { useState } from "react";
import { ModalContent, ButtonContainer } from "./styles";
import { Check, CancelOutlined } from "@mui/icons-material";
import { Modal } from "@/components/modal-base";
import { Input } from "@/components/inputs";

interface IAccountsTokenName {
  modal: boolean;
  toggleModal: () => void;
  generateToken: (tokenName: string) => Promise<void>;
}

export const AccountsTokenName: React.FC<IAccountsTokenName> = ({
  modal,
  toggleModal,
  generateToken,
}) => {
  const [tokenName, setTokenName] = useState<string>("");

  const handleNavigate = () => {
    toggleModal();
    generateToken(tokenName);
    setTokenName("");
  };

  const handleCloseModal = (
    event: React.ChangeEvent<HTMLInputElement> | React.MouseEvent
  ) => {
    event.preventDefault();
    toggleModal();
  };

  return (
    <Modal.Root maxWidth="600px" open={modal} onClose={handleCloseModal}>
      <Modal.Header justifyContent="end">
        <Modal.HeaderText text="Nome para o Token" />
        <Modal.Icon
          icon="Close"
          cursor="pointer"
          onClick={handleCloseModal}
          iconColor="black"
        />
      </Modal.Header>
      <Modal.Content>
        <ModalContent>
          <Input.Label
            setValue={setTokenName}
            value={tokenName}
            label="Informe um nome para identificação"
          />
          <ButtonContainer>
            <Modal.Button
              onClick={handleNavigate}
              startIcon={<Check />}
              bgColor="#2C2C2C"
              color="white"
              disabled={!tokenName}
            >
              Cadastrar
            </Modal.Button>
            <Modal.Button
              onClick={toggleModal}
              startIcon={<CancelOutlined />}
              bgColor="#2C2C2C"
              color="white"
            >
              Cancelar
            </Modal.Button>
          </ButtonContainer>
        </ModalContent>
      </Modal.Content>
    </Modal.Root>
  );
};
